import React, { useEffect, useState, useCallback } from 'react';
import {
    Box,
    Typography,
    Toolbar,
    ImageList,
    ImageListItem,
    Dialog,
    IconButton
} from '@mui/material';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const Gallery = ({ pictures = [] }) => {
    const [open, setOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleOpen = (index) => {
        if (!Array.isArray(pictures) || pictures.length === 0) return;
        if (index < 0 || index >= pictures.length) return;
        setCurrentIndex(index);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handlePrev = useCallback(() => {
        setCurrentIndex((prev) => {
            if (!pictures || pictures.length === 0) return 0;
            return prev === 0 ? pictures.length - 1 : prev - 1;
        });
    }, [pictures]);

    const handleNext = useCallback(() => {
        setCurrentIndex((prev) => {
            if (!pictures || pictures.length === 0) return 0;
            return prev === pictures.length - 1 ? 0 : prev + 1;
        });
    }, [pictures]);

    useEffect(() => {
        if (!open) return;

        const onKey = (e) => {
            if (e.key === 'ArrowLeft') {
                handlePrev();
            } else if (e.key === 'ArrowRight') {
                handleNext();
            } else if (e.key === 'Escape') {
                handleClose();
            }
        };

        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [open, handlePrev, handleNext]);

    const currentPicture = pictures?.[currentIndex];

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar />
            <Toolbar />
            <Box sx={{ width: '90%', mx: 'auto', flex: 1, py: 4, textAlign: 'center' }}>
                <Typography variant="h2" component="h1" gutterBottom>
                    Gallery
                </Typography>

                <ImageList variant="masonry" cols={3} gap={8}>
                    {pictures.map((picture, index) => (
                        <ImageListItem 
                            key={index} 
                            onClick={() => handleOpen(index)} 
                            sx={{ 
                                cursor: 'pointer',
                                transition: '0.3s',
								'&:hover': { transform: 'translateY(-5px)', boxShadow: 6 },
                                }}>
                            <img
                                srcSet={
                                    picture?.Link
                                        ? `${picture.Link}?w=248&fit=crop&auto=format&dpr=2 2x`
                                        : undefined
                                }
                                src={picture?.Link ? `${picture.Link}?w=248&fit=crop&auto=format` : undefined}
                                alt={picture?.Caption || ''}
                                loading="lazy"
                                style={{ width: '100%', display: 'block' }}
                            />
                            {/* <ImageListItemBar title={picture?.Caption} /> */}
                        </ImageListItem>
                    ))}
                </ImageList>

                <Dialog
                    open={open && !!currentPicture}
                    onClose={handleClose}
                    maxWidth="lg"
                    PaperProps={{
                        sx: { backgroundColor: 'rgba(24,24,24,0.95)' },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "80vh",
                            minWidth: "80vw",
                            position: "relative",
                        }}
                    >
                        <Box
                            sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                px: 2,
                                py: 1,
                                background: "rgba(24,24,24)",
                                color: "white",
                            }}
                        >
                            <Typography variant="h6" sx={{paddingLeft: 2}}>{pictures[currentIndex]?.Caption}</Typography>
                            <IconButton onClick={handleClose} sx={{ color: "white" }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        <Box
                            sx={{
                                flex: 1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <img
                                src={pictures[currentIndex]?.Link}
                                alt={pictures[currentIndex]?.Caption}
                                style={{
                                    maxHeight: "70vh",
                                    maxWidth: "80vw",
                                    objectFit: "contain",
                                }}
                            />
                        </Box>

                        <IconButton
                            onClick={handlePrev}
                            sx={{ position: "absolute", left: 16, top: "50%", color: "white" }}
                        >
                            <ArrowBackIosNewIcon />
                        </IconButton>
                        <IconButton
                            onClick={handleNext}
                            sx={{ position: "absolute", right: 16, top: "50%", color: "white" }}
                        >
                            <ArrowForwardIosIcon />
                        </IconButton>
                    </Box>

                </Dialog>
            </Box>
            <Footer/>
        </Box>
    );
};

export default Gallery;
